module.exports = __webpack_public_path__ + "media/banner_video.750c87a4.mp4";